import Device from '@/models/Device'
import Api from '@/api'

export default {
  namespaced: true,
  state: {
    deviceDetails: null
  },

  mutations: {
    setDeviceDetails(state, device) {
      if (device instanceof Device) {
        state.deviceDetails = device
      } else {
        state.deviceDetails = new Device(device)
      }
    },

    clearDeviceDetails(state) {
      state.deviceDetails = null
    }
  },

  actions: {
    async storeDevice({ commit }, formData) {
      const { data } = await Api.post(`devices`, {
        device_token: formData.token,
        device_id: formData.id
      })

      commit('setDeviceDetails', data.data)
    },

    async deleteDevice({ commit, state }) {
      await Api.delete(`devices`, {
        data: {
          device_token: state.deviceDetails.token,
          device_id: state.deviceDetails.device_id
        }
      })
      commit('clearDeviceDetails')
    }
  }
}
